<template>
  <div>
    <Preview
      :dataContract="dataContract"
      :srcPDF="srcPDF"
      showAction
      @confirm="conFirmHD"
    ></Preview>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { ContractService } from '@/services/contract.service'
  import { ReviewService } from '@/services/review.service'
  import Preview from '@/pages/contract/component/preview/preview'
  export default {
    data() {
      return {
        showLoading: true,
        dataContract: {},
        srcPDF: null,
      }
    },

    components: { Preview },

    async created() {
      try {
        const param = this.$route.query
        if (!param || !param.contractId || !param.version || !param.codeVerify || !param.token) {
          this.showFailMx('Thông tin không hợp lệ !')
          return
        }
        const dataContractRespon = await ContractService.previewAndPdf2({
          econtractId: param.contractId,
          token: this.$route.query.token,
          type: 'PREVIEW',
        })
        if (dataContractRespon.code === 1000) {
          this.dataContract = dataContractRespon.data
          if (this.dataContract.typeCustomer && this.dataContract.typeCustomer === 'COMPANY') {
            await this.getLinkPDFBusinessContract()
          }
          const dataCheckVerify = await ReviewService.checkCodeVerify({
            codeVerify: param.codeVerify,
            contractId: param.contractId,
            token: param.token,
          })
          if (
            dataCheckVerify.code === 1000 &&
            dataCheckVerify.data.codeVerify === param.codeVerify
          ) {
            return
          }
          this.showFailMx('Mã xác nhận không hợp lệ')
          return
        } else {
          this.showFailMx('Mã hợp đồng không hợp lệ !')
        }
      } catch (err) {
        this.showFailMx(err)
        console.log(err)
      } finally {
        this.showLoading = false
      }
    },
    methods: {
      async conFirmHD(state) {
        try {
          this.showLoading = true
          let data = null
          let body = {}
          if (
            this.dataContract.typeCustomer &&
            this.dataContract.typeCustomer === 'COMPANY' &&
            state
          ) {
            data = await this.genPDFByServer_Megadoc(state)
          } else {
            body = {
              econtractId: this.$route.query.contractId,
              token: this.$route.query.token,
              isMerchantAgree: state,
            }
            data = await ReviewService.comfirmReview(body)
          }
          if (data.success) {
            this.showSuccessMx(data.message)
            const dataContractRespon = await ReviewService.getEcontractByID({
              econtractId: this.$route.query.contractId,
              token: this.$route.query.token,
            })
            if (dataContractRespon.data.code === 1000) {
              this.dataContract = dataContractRespon.data.data
              return
            } else {
              this.showFailMx('Mã hợp đồng không hợp lệ !')
            }
          } else {
            this.showFailMx(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.showLoading = false
        }
      },

      async genPDFByServer_Megadoc(state) {
        let data = {}
        if (state === true) {
          this.showModalGenMegadoc = true
          const bodyReqMegadoc = {
            token: this.$route.query.token,
            code: this.dataContract.code,
            groupService: this.dataContract.groupService,
          }
          const response = await ContractService.genPDFByServer_Megadoc(bodyReqMegadoc)
          if (response.code === 1000) {
            this.megadocURL = `${window._env_?.VUE_APP_GET_CCRP_CONFIG ?? process.env.VUE_APP_GET_CCRP_CONFIG}/file/${response.message}`
            const body = {
              econtractId: this.$route.query.contractId,
              token: this.$route.query.token,
              isMerchantAgree: state,
              urlS3: this.megadocURL,
            }
            data = await ReviewService.comfirmReviewMegadoc(body)
          } else if (response.code === 98074) {
            const body = {
              econtractId: this.$route.query.contractId,
              token: this.$route.query.token,
              isMerchantAgree: state,
            }
            data = await ReviewService.comfirmReview(body)
          } else {
            this.showFailMx(response.message)
          }
        } else {
          const body = {
            econtractId: this.$route.query.contractId,
            token: this.$route.query.token,
            isMerchantAgree: state,
          }
          data = await ReviewService.comfirmReviewMegadoc(body)
        }
        return data
      },
      async getLinkPDFBusinessContract() {
        try {
          const param = this.$route.query
          const body = {
            contractId: this.dataContract.id,
            appendixId: '',
            token: param.token,
          }

          const data = await ReviewService.getLinkPDFBusinessContract(body)
          if (data.code === 1000) {
            const start = data.message.indexOf('accessKeyS3=')

            const accessKeyS3 = data.message.substring(start + 12, data.message.length)

            const body = {
              contractId: this.dataContract.id,
              accessKeyS3: accessKeyS3,
            }

            const dataContractRespon = await ContractService.getLinkPDF(body)
            if (dataContractRespon.success) {
              this.srcPDF = `${dataContractRespon.data.urlContractS3}?key=${accessKeyS3}`
            }
          } else {
            console.log(data.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
